import React from 'react';
import PropTypes from 'prop-types';
import map from 'lodash/map';

import { formatCurrency } from 'pages/MyAccount/utils/currency';
import styles from './InvoiceHistory.module.css';
import { taxTextsByCountry } from '../../constants';

const InvoiceDetails = ({
  creditAppliedInCents,
  discountInCents,
  invoiceNumber,
  lineItems,
  subTotalInCents,
  taxInCents,
  calculatedTotal,
  countryCode,
}) => {
  const taxTexts = taxTextsByCountry(countryCode);
  return (
    <div className={styles.invoiceDetailsContainer}>
      <div className={styles.orderDetails}>
        <h4>Order Details</h4>
      </div>
      {map(lineItems, (item, index) => {
        const { unitAmountInCents, quantity, description } = item;
        return (
          <div
            data-testid="invoice-line-item-row"
            key={`${invoiceNumber}-item-${index}`}
            className={styles.lineItemDetail}
          >
            <div className={styles.invoiceDetails}>
              <div>{description}</div>
              <div>
                <div>{formatCurrency(unitAmountInCents / 100)}</div>
                <div className={styles.itemQuantity}>{`x${quantity}`}</div>
              </div>
            </div>
          </div>
        );
      })}
      <div className={styles.invoiceFinancials}>
        <div className={styles.invoiceFinancialItem}>
          <div>Subtotal</div>
          <div>{formatCurrency(subTotalInCents / 100)}</div>
        </div>
        {discountInCents > 0 && (
          <div className={styles.invoiceFinancialItem}>
            <div>Discount</div>
            <div>{formatCurrency(-discountInCents / 100)}</div>
          </div>
        )}
        {taxInCents > 0 && (
          <div className={styles.invoiceFinancialItem}>
            <div>{`${taxTexts.description}${taxTexts.disclaimer ? '*' : ''}`}</div>
            <div>{formatCurrency(taxInCents / 100)}</div>
          </div>
        )}
        {creditAppliedInCents > 0 && (
          <div className={styles.invoiceFinancialItem}>
            <div>Promotional Credit</div>
            <div>{formatCurrency(-creditAppliedInCents / 100)}</div>
          </div>
        )}
      </div>
      <div className={styles.orderTotal}>
        <p>Order Total</p>
        <p>{formatCurrency(calculatedTotal)}</p>
      </div>
      {taxInCents > 0 && taxTexts.disclaimer && (
        <div className={styles.invoiceFinancialItem}>
          <div>{taxTexts.disclaimer}</div>
        </div>
      )}
    </div>
  );
};

InvoiceDetails.propTypes = {
  creditAppliedInCents: PropTypes.number.isRequired,
  invoiceNumber: PropTypes.string.isRequired,
  lineItems: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  subTotalInCents: PropTypes.number.isRequired,
  taxInCents: PropTypes.number.isRequired,
  calculatedTotal: PropTypes.number.isRequired,
  countryCode: PropTypes.string.isRequired,
};

export default InvoiceDetails;
